import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import NotifySnackbar from 'components/Utility/Snackbars/NotifySnackbar';
import SearchBar from 'material-ui-search-bar';
import React from 'react';
import { isBrowser, isMobile } from 'react-device-detect';
import Loader from 'react-overlay-loader/lib/Loader';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { fetchACLUsers } from '../../../../../actions/authentication';
import { DepositFilterTypes } from '../../../../../utils/constants/deposits';
import './index.scss';
import UserDetailsModal from './UserDetailsModal';
import UsersTable from './UsersTable';

const ListPadding = styled.div`
  padding: 30px 20px 20px;
  @media only screen and (max-width: 680px) {
    padding: 15px 10px;
  }
`;

const ListContainer = styled.div`
  background-color: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  border: 1px solid #cccccc;
  max-width: 1120px;
  margin: auto;
  padding: 49px 24px 51px 49px;
  h1 {
    font-size: 18px;
  }
`;

const ListHeader = styled.div`
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  width: 100%;
  h1 {
    font-size: 32px;
    font-weight: 500;
  }
`;

class ViewUsersPanel extends React.Component {
  state = {
    timer: null,
    isSearching: false,
    searchValue: '',
    selectedBooking: null,
    showDetailsModal: false,
    subscribedToPusher: false,
    showBookingNotification: false,
    pendingBookingsOnly: false,
    newestBooking: null,
    currentDate: null,
    errorFetchingMenus: false,
    isPending: false,
    searchResults: [],
    filterType: DepositFilterTypes.ALL_DEPOSITS,
  };

  constructor(props) {
    super(props);
    this.dateInputRef = React.createRef();
  }

  componentDidMount() {
    this.props.fetchACLUsers();
  }

  render() {
    const loadingSearch = this.props.fetchingSearchBookings;

    return (
      <div className="view-bookings">
        {isMobile && (
          <Button
            onClick={this.showBookingModal}
            variant="fab"
            color="primary"
            aria-label="add"
            className="add__booking__btn__mobile"
          >
            <Icon>add</Icon>
          </Button>
        )}
        <ListPadding>
          <ListContainer>
            <ListHeader>
              <h1>Users</h1>
              {isBrowser && (
                <Button
                  onClick={this.showBookingModal}
                  className="add__booking__btn__desktop"
                  color="primary"
                  variant="contained"
                >
                  <span className="add__booking__btn__text">Add User</span>
                </Button>
              )}
            </ListHeader>
            <div className="datetime__container">
              <div className="search__wrapper">
                {' '}
                <SearchBar
                  className="bookings__search__bar"
                  placeholder="Search Name"
                  value={this.state.searchValue}
                  onChange={searchValue => this.onSearchRequest(searchValue)}
                  onRequestSearch={() =>
                    this.onSearchRequest(this.state.searchValue)
                  }
                  onCancelSearch={() => this.onSearchRequest('')}
                />
              </div>
            </div>
            <Paper
              className="bookings__paper"
              style={{
                borderRadius: 4,
                marginBottom: 24,
                boxShadow:
                  ' 0px 1px 0px 0px rgba(0, 0, 0, 0.2),0px -1px 0px 0px rgba(0, 0, 0, 0.2), 1px 0px 0px 0px rgba(0, 0, 0, 0.2),-1px 0px 0px 0px rgba(0, 0, 0, 0.2)',
              }}
            >
              <UsersTable
                venue={this.props.venue}
                loading={loadingSearch}
                bookingList={this.props.users || []}
                searchValue={this.state.searchValue}
                searchResults={this.state.searchResults}
                showBookingModal={this.showBookingModal}
              />
            </Paper>
          </ListContainer>
        </ListPadding>
        <UserDetailsModal
          //askForTime={venueSteps.hasBookingTime}
          onComplete={this.completeDetailsModal}
          open={this.state.showDetailsModal}
          onClose={this.closeDetailsModal}
          booking={this.state.selectedBooking}
          fetchReservations={this.props.fetchACLUsers}
        />

        <NotifySnackbar
          open={this.state.showBookingNotification}
          onClose={() => this.setState({ showBookingNotification: false })}
          actionIcon="visibility"
          onAction={() => this.showBookingModal(this.state.newestBooking)}
        />

        <Loader
          loading={this.props.sendingReminder || this.props.fetchingMenus}
        />
      </div>
    );
  }

  showBookingModal = booking => {
    if (!booking.id) {
      booking = undefined;
    }

    this.setState({ selectedBooking: booking, showDetailsModal: true });
  };

  closeDetailsModal = () =>
    this.setState({ showDetailsModal: false, selectedBooking: undefined });

  completeDetailsModal = (reloadAll = true) => {
    this.setState({ showDetailsModal: false, selectedBooking: undefined });

    // Re-fetch all the things
    if (reloadAll) {
      this.reloadAll();
    }
  };

  onSearchRequest = query => {
    if (query !== '') {
      const searchResults = this.props.users.filter(user =>
        user.forename.toLowerCase().includes(query.toLowerCase())
      );

      if (searchResults.length === 0) {
        this.setState({
          searchResults: [],
          isSearching: true,
          searchValue: query,
        });
      }

      this.setState({ searchResults, isSearching: true, searchValue: query });
    } else {
      this.setState({ searchResults: [], isSearching: false, searchValue: '' });
    }
  };

  reloadAll = () => {
    // this.fetchBookings(this.getSelectedDate());
    // this.fetchPendingBookings();
    // this.onSearchRequest(this.state.searchValue);
  };
}

const mapStateToProps = state => {
  return {
    venue: state.venue,
    users:
      (state.authentication.ACLUsers && state.authentication.ACLUsers.users) ||
      [],
    error: state.error,
  };
};

const mapDispatchToProps = dispatch => ({
  fetchACLUsers: () => dispatch(fetchACLUsers()),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ViewUsersPanel)
);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Users/ViewUsersPanel/index.jsx